
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u",
      function () {
        return require("private-next-pages/u/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u"])
      });
    }
  